import {FC} from "react";
import {useScript} from "./useScript";
import {ScriptDefinition} from "./ScriptDefinition";

/**
 * Can be placed anywhere in the page to dynamically inject a script, designed
 * to work in conjunction with Custom Elements.
 *
 * This component presents no user interface, it merely wraps the {@link useScript} hook.
 *
 * If presenting a loading status user interface is desired, the ScriptLoader
 * or ScriptObserver may be used.
 *
 * @param props
 * @constructor
 * @see useScript
 * @see ScriptLoader
 * @see ScriptObserver
 */
export const Script: FC<ScriptDefinition> = props => {
  useScript(props);
  // prettier-ignore
  return null;
};
